import { useLang } from "@/context";
import { Reveal } from "@/components/Reveal";

export default function TrustSection() {
  const { t } = useLang();

  return (
    <section data-testid="trust-section" className="bg-dark text-ivory py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <Reveal className="flex items-center gap-4 mb-10 sm:mb-14">
          <span className="gold-rule w-14" aria-hidden="true" />
          <span className="text-[11px] sm:text-xs uppercase tracking-[0.34em] text-gold">
            {t.trust.label}
          </span>
        </Reveal>

        <div className="grid grid-cols-12 gap-y-10 lg:gap-16">
          <div className="col-span-12 lg:col-span-5 min-w-0">
            <Reveal>
              <h2
                data-testid="trust-title"
                className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.08]"
              >
                {t.trust.title}
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 min-w-0">
            <Reveal delay={0.15}>
              <p data-testid="trust-copy" className="text-base sm:text-lg text-taupe leading-relaxed font-light">
                {t.trust.p1}
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-6 text-sm sm:text-base text-taupe/80 leading-relaxed font-light">
                {t.trust.p2}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 sm:mt-24 grid grid-cols-1 sm:grid-cols-3 gap-y-8 sm:gap-x-10">
          {t.trust.words.map((word, i) => (
            <Reveal key={word} delay={i * 0.1}>
              <div data-testid={`trust-word-${i}`}>
                <span className="font-serif text-3xl sm:text-4xl lg:text-[2.8rem] uppercase tracking-[0.1em] text-outline-taupe">
                  {word}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
